(function () {
  'use strict';

  var retailers = JSON.parse(document.getElementById('locator-data').textContent);
  var cfg = window.__locatorConfig;

  mapboxgl.accessToken = cfg.token;

  var map = new mapboxgl.Map({
    container: 'locator-map',
    style: cfg.style,
    center: [15, 25],
    zoom: 1
  });

  map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');
  map.addControl(new mapboxgl.GeolocateControl({ positionOptions: { enableHighAccuracy: true } }), 'top-right');

  function toGeoJSON(items) {
    return {
      type: 'FeatureCollection',
      features: items.map(function (r) {
        return {
          type: 'Feature',
          geometry: { type: 'Point', coordinates: [parseFloat(r.lng), parseFloat(r.lat)] },
          properties: { id: r.id, name: r.name, city: r.city, country_name: r.country_name }
        };
      })
    };
  }

  var suppressPanHighlight = false;

  function fitBounds(items, opts) {
    if (!items.length) return;
    var bounds = new mapboxgl.LngLatBounds();
    items.forEach(function (r) { bounds.extend([parseFloat(r.lng), parseFloat(r.lat)]); });
    suppressPanHighlight = true;
    setTimeout(function () { suppressPanHighlight = false; }, 1000);
    map.fitBounds(bounds, Object.assign({ padding: 60, maxZoom: 8, duration: 800 }, opts || {}));
  }

  map.on('style.load', function () {
    var bgLayer = map.getStyle().layers.find(function (l) { return l.type === 'background'; });
    if (bgLayer) map.setPaintProperty(bgLayer.id, 'background-color', '#FCF9F1');
    // Globe projection: the area around the sphere is fog/space, not the container.
    // Flatten it to the cream so no white ring shows around the globe.
    map.setFog({
      'color': '#FCF9F1',
      'high-color': '#FCF9F1',
      'space-color': '#FCF9F1',
      'horizon-blend': 0,
      'star-intensity': 0
    });
  });

  map.on('load', function () {
    map.addSource('retailers', {
      type: 'geojson',
      data: toGeoJSON(retailers),
      cluster: true,
      clusterMaxZoom: 10,
      clusterRadius: 50
    });

    map.addLayer({
      id: 'clusters',
      type: 'circle',
      source: 'retailers',
      filter: ['has', 'point_count'],
      paint: {
        'circle-color': '#003087',
        'circle-radius': ['step', ['get', 'point_count'], 16, 5, 22, 10, 28],
        'circle-stroke-width': 2,
        'circle-stroke-color': '#FCF9F1'
      }
    });

    map.addLayer({
      id: 'cluster-count',
      type: 'symbol',
      source: 'retailers',
      filter: ['has', 'point_count'],
      layout: {
        'text-field': '{point_count_abbreviated}',
        'text-size': 12,
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold']
      },
      paint: { 'text-color': '#FCF9F1' }
    });

    map.addLayer({
      id: 'unclustered-point',
      type: 'circle',
      source: 'retailers',
      filter: ['!', ['has', 'point_count']],
      paint: {
        'circle-color': '#003087',
        'circle-radius': 7,
        'circle-stroke-width': 2,
        'circle-stroke-color': '#FCF9F1'
      }
    });

    fitBounds(retailers, { maxZoom: 4 });
  });

  map.on('click', 'clusters', function (e) {
    var feature = map.queryRenderedFeatures(e.point, { layers: ['clusters'] })[0];
    map.getSource('retailers').getClusterExpansionZoom(feature.properties.cluster_id, function (err, zoom) {
      if (!err) map.easeTo({ center: feature.geometry.coordinates, zoom: zoom });
    });
  });

  ['clusters', 'unclustered-point'].forEach(function (layer) {
    map.on('mouseenter', layer, function () { map.getCanvas().style.cursor = 'pointer'; });
    map.on('mouseleave', layer, function () { map.getCanvas().style.cursor = ''; });
  });

  var activePopup = null;

  map.on('click', 'unclustered-point', function (e) {
    var id = e.features[0].properties.id;
    var r = retailers.find(function (x) { return x.id === id; });
    if (!r) return;
    openPopup(r, e.features[0].geometry.coordinates.slice());
    openDrawerForRegion(r.region);
    scrollToCard(id);
    expandCard(id);
  });

  function openPopup(r, coords) {
    if (activePopup) activePopup.remove();
    activePopup = new mapboxgl.Popup({ offset: 12, maxWidth: '240px' })
      .setLngLat(coords)
      .setHTML('<strong>' + r.name + '</strong><br>' + r.city + ', ' + r.country_name)
      .addTo(map);
  }

  function findCard(id) {
    return Array.from(document.querySelectorAll('.retailer-card'))
      .find(function (c) { return c.dataset.retailerId === id; }) || null;
  }

  // Drawer helpers — accordion: only one region open at a time
  function openDrawerForRegion(region) {
    document.querySelectorAll('.store-locator__region-group').forEach(function (g) {
      var isTarget = g.dataset.regionGroup === region;
      g.classList.toggle('is-open', isTarget);
      var btn = g.querySelector('.store-locator__drawer-btn');
      if (btn) btn.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
    });
  }

  function closeAllDrawers() {
    document.querySelectorAll('.store-locator__region-group').forEach(function (g) {
      g.classList.remove('is-open');
      var btn = g.querySelector('.store-locator__drawer-btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function scrollToCard(id) {
    var card = findCard(id);
    if (!card) return;
    setTimeout(function () {
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 50);
  }

  function expandCard(id) {
    document.querySelectorAll('.retailer-card.is-expanded').forEach(function (c) {
      if (c.dataset.retailerId !== id) {
        c.classList.remove('is-expanded');
        c.setAttribute('aria-expanded', 'false');
      }
    });
    var card = findCard(id);
    if (!card) return;
    var opening = !card.classList.contains('is-expanded');
    card.classList.toggle('is-expanded');
    card.setAttribute('aria-expanded', opening ? 'true' : 'false');
  }

  // Drawer toggle (accordion)
  document.querySelectorAll('.store-locator__drawer-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var region = btn.dataset.drawer;
      var group = btn.closest('.store-locator__region-group');
      var isOpen = group.classList.contains('is-open');

      if (isOpen) {
        closeAllDrawers();
        fitBounds(retailers, { maxZoom: 4 });
      } else {
        openDrawerForRegion(region);
        var regionRetailers = retailers.filter(function (r) { return r.region === region; });
        fitBounds(regionRetailers, { maxZoom: 8 });
      }
      clearDimming();
    });
  });

  document.querySelectorAll('.retailer-card').forEach(function (card) {
    card.addEventListener('click', function () {
      var id = card.dataset.retailerId;
      var r = retailers.find(function (x) { return x.id === id; });
      if (!r) return;
      expandCard(id);
      map.flyTo({ center: [parseFloat(r.lng), parseFloat(r.lat)], zoom: 12 });
      openPopup(r, [parseFloat(r.lng), parseFloat(r.lat)]);
      if (window.innerWidth < 768) switchView('map');
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
    });
  });

  // Search
  var searchTimer = null;
  var currentQuery = '';

  document.querySelector('.store-locator__search').addEventListener('input', function (e) {
    clearTimeout(searchTimer);
    var val = e.target.value;
    searchTimer = setTimeout(function () {
      currentQuery = val.trim().toLowerCase();
      applyFilter();
    }, 200);
  });

  function applyFilter(fitOpts) {
    clearDimming();
    var q = currentQuery;
    var filtered = retailers.filter(function (r) {
      return !q ||
        r.name.toLowerCase().includes(q) ||
        r.city.toLowerCase().includes(q) ||
        r.country_name.toLowerCase().includes(q) ||
        r.country_code.toLowerCase().includes(q);
    });

    if (map.getSource('retailers')) {
      map.getSource('retailers').setData(toGeoJSON(filtered));
    }

    document.querySelectorAll('.retailer-card').forEach(function (card) {
      var match = filtered.some(function (r) { return r.id === card.dataset.retailerId; });
      card.hidden = !match;
    });

    document.querySelectorAll('.store-locator__country-group').forEach(function (group) {
      group.hidden = group.querySelectorAll('.retailer-card:not([hidden])').length === 0;
    });

    document.querySelectorAll('.store-locator__region-group').forEach(function (group) {
      var hasVisible = group.querySelectorAll('.retailer-card:not([hidden])').length > 0;
      var drawerBtn = group.querySelector('.store-locator__drawer-btn');
      if (q) {
        group.hidden = !hasVisible;
        if (hasVisible) {
          group.classList.add('is-open');
          if (drawerBtn) drawerBtn.setAttribute('aria-expanded', 'true');
        }
      } else {
        group.hidden = false;
        group.classList.remove('is-open');
        if (drawerBtn) drawerBtn.setAttribute('aria-expanded', 'false');
      }
    });

    var noResults = document.querySelector('.store-locator__no-results');
    if (noResults) noResults.hidden = filtered.length > 0;

    if (filtered.length && map.getSource('retailers')) fitBounds(filtered, fitOpts);
  }

  // Map pan → dim out-of-bounds cards in the open drawer only
  map.on('moveend', function () {
    if (suppressPanHighlight || currentQuery) return;
    var bounds = map.getBounds();
    document.querySelectorAll('.retailer-card:not([hidden])').forEach(function (card) {
      var regionGroup = card.closest('.store-locator__region-group');
      if (!regionGroup || !regionGroup.classList.contains('is-open')) return;
      var r = retailers.find(function (x) { return x.id === card.dataset.retailerId; });
      if (!r) return;
      var inBounds = bounds.contains([parseFloat(r.lng), parseFloat(r.lat)]);
      card.classList.toggle('is-dimmed', !inBounds);
    });
  });

  function clearDimming() {
    document.querySelectorAll('.retailer-card.is-dimmed').forEach(function (c) {
      c.classList.remove('is-dimmed');
    });
  }

  document.querySelector('.store-locator__search').addEventListener('focus', clearDimming);

  // Mobile toggle
  function switchView(view) {
    var panel = document.getElementById('locator-panel');
    var mapWrap = document.getElementById('locator-map-wrap');
    document.querySelectorAll('.store-locator__toggle-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.view === view);
    });
    if (view === 'map') {
      panel.style.display = 'none';
      // Explicit value — '' would fall back to the mobile `display:none` rule and hide the map.
      mapWrap.style.display = 'block';
      // Resize after the container is laid out, else the GL canvas keeps its 0-size.
      requestAnimationFrame(function () { map.resize(); });
    } else {
      panel.style.display = '';
      mapWrap.style.display = 'none';
    }
  }

  document.querySelectorAll('.store-locator__toggle-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { switchView(btn.dataset.view); });
  });
})();
